export default "__VITE_ASSET__69300c4d__"